module.exports = __webpack_public_path__ + "img/bild-m.f5311987.png";